import { useState } from "react";
import axios from "axios";

export default function NewUserForm() {
  const token = localStorage.getItem("token"); 
  const [form, setForm] = useState({
    ime: "",
    adresa: "",
    grad: "",
    telefon: "",
    email: "",
    password: "",
    uloga: ""
  });

  const [msg, setMsg] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(
      `/api/clients`,
      form
    , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      setMsg("Klijent dodat uspešno ✅");

      setForm({
        ime: "",
        adresa: "",
        grad: "",
        telefon: "",
        email: "",
        password: "",
        uloga: ""
      });
    })
    .catch(err => {
      console.error(err);
      setMsg("Greška pri dodavanju ❌");
    });
  };

  return (
    <div className="card bg-dark text-white p-4">
      <h4>Dodaj novog klijenta</h4>

      <form onSubmit={handleSubmit}>

        <input
          className="form-control mb-2 w-25"
          name="ime"
          placeholder="Ime"
          value={form.ime}
          onChange={handleChange}
          required
        />

        <input
          className="form-control mb-2 w-25"
          name="adresa"
          placeholder="Adresa"
          value={form.adresa}
          onChange={handleChange}
        />

        <input
          className="form-control mb-2 w-25"
          name="grad"
          placeholder="Grad"
          value={form.grad}
          onChange={handleChange}
        />

        <input
          className="form-control mb-2 w-25"
          name="telefon"
          placeholder="---"
          value={form.telefon}
          onChange={handleChange}
        />

        <input
          className="form-control mb-2 w-25"
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />

        <input
          className="form-control mb-3 w-25"
          name="password"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />

          <input
          className="form-control mb-3 w-25"
          name="uloga"
          placeholder="uloga"
          value={form.uloga}
          onChange={handleChange}
        />

        <button className="btn btn-primary w-25">
          Dodaj klijenta
        </button>

      </form>

      {msg && <p className="mt-3">{msg}</p>}
    </div>
  );
}